export const COMMODITIES = [
  'Aluminium',
  'Ammonia',
  'Antimony',
  'Arsenic',
  'Barium',
  'Bauxite',
  'Beryllium',
  'Bismuth',
  'Boron',
  'Caesium',
  'Calcium Carbonate',
  'Chromite',
  'Chromium',
  'Clinker',
  'Coal',
  'Cobalt',
  'Copper',
  'Diamonds',
  'Dolerite',
  'Dysprosium',
  'Feldspar',
  'Fluorine',
  'Fluorspar',
  'Gallium',
  'Garnet',
  'Germanium',
  'Gold',
  'Granite',
  'Graphite',
  'Gypsum',
  'Hafnium',
  'Halloysite',
  'Helium',
  'Hydrocarbon',
  'Hydrogen',
  'Ilmenite',
  'Indium',
  'Iridium',
  'Iron Ore',
  'Kaolin',
  'Lead',
  'Lepidolite',
  'Leucoxene',
  'Limestone',
  'Lithium',
  'LNG',
  'Magnesium',
  'Manganese',
  'Mineral Sands',
  'Monazite',
  'Molybdenum',
  'Muscovite',
  'Neodymium',
  'Nickel',
  'Niobium',
  'Nitrogen',
  'Osmium',
  'Palladium',
  'Petroleum',
  'Phosphate',
  'Phosphorus',
  'Platinum',
  'Polymetallic Nodule',
  'Potash',
  'Potassium',
  'Praseodymium',
  'Quartz',
  'Rare Earth Elements',
  'Rhenium',
  'Rhodium',
  'Rubidium',
  'Ruthenium',
  'Rutile',
  'Scandium',
  'Silica Sand',
  'Silicon',
  'Silver',
  'Sodium Chloride',
  'Strontium',
  'Sulphur',
  'Tantalite',
  'Tantalum',
  'Terbium',
  'Tellurium',
  'Thorium',
  'Tin',
  'Titanium',
  'Topaz',
  'Torbanite',
  'Tungsten',
  'Uranium',
  'Urea',
  'Vanadium',
  'Volcanogenic Massive Sulfide',
  'Xenotime',
  'Zinc',
  'Zircon',
  'Zirconium',
  'Other',
]

export const PROJECT_STAGES = [
  'Exploration',
  'Pre-Feasibility',
  'Feasibility',
  'Development',
  'Production',
  'Brownfield',
  'Care & Maintenance',
  'Rehabilitation and Closure'
]

export const EMPLOYEE_SIZES = [
  '1-10',
  '11-50',
  '51-200',
  '201-500',
  '501-1000',
  '1001-5000',
  '5001-10000',
  '10000+',
]

const DEFAULT_SOFTWARE = [
  'SAP',
  'Oracle',
  'Microsoft Dynamics',
  'Workday',
  'Salesforce',
  'AutoCAD',
  'Revit',
  'AVEVA',
  'Aspen',
  'Other',
]

const MINING_SOFTWARE = [
  'Micromine',
  'Leapfrog Geo',
  'Leapfrog Edge',
  'Datamine Studio RM',
  'Studio 3',
  'Surpac',
  'Vulcan',
  'Seequent Central',
  'Deswik.CAD',
  'Deswik.MDM',
  'MineSight',
  'Hexagon MinePlan',
  'Datamine Studio UG',
  'Datamine Studio OP',
  'LogChief',
  'Geobank Mobile',
  'MX Deposit',
  'acQuire',
  "Brent's LogChief",
  'Excel',
  'Access',
  'Power BI',
  'ArcGIS',
  'ArcGIS Pro (ESRI)',
  'QGIS',
  'MapInfo Professional',
  'Supervisor (Datamine)',
  'Isatis.neo',
  'FieldMove',
  'FieldMove Clino',
  'Collect',
  'REFLEX IQ Logger',
  'Imdex HUB-IQ',
  'Imago',
  'Geosoft Oasis Montaj',
  'Petra Data Science',
  'Seequent AI',
  'RockWorks',
]

export const SOFTWARE_LOOKUPS: Record<string, readonly string[]> = {
  default: DEFAULT_SOFTWARE,
  mining: MINING_SOFTWARE,
}

export const SOFTWARE_OPTIONS = DEFAULT_SOFTWARE
